import '../styles/reset.css';
import '../styles/root.css';
import '../styles/global.css';
import '../styles/main.css';
import { Link, useNavigate } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';

function Main() {
  const navigate = useNavigate();

  const handleService = (id: string) => {
    switch (id) {
      case 'uxbooster':
        navigate(`/uxbooster`);
        break;
      case 'aichanger':
        navigate(`/aichanger`);
        break;
      case 'gems':
        navigate(`/gems`);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      {/* 배너 */}
      <section id="main-banner" className="main-banner">
        <div className="m-auto main-banner-container">
          <div className="main-banner-content">
            <div className="banner-action">
              <div className="slide-rtl banner-line">
                <img className="img-takeaction" src="./images/img-takeaction.svg" alt="" />
                <img className="img-takeaction-mo" src="./images/img-takeaction-mo.svg" alt="" />
                <div className="aboutus">
                  <p className="slide-top pb-4">
                    <Link to="/intro">
                      <img src="./images/ico-aboutus.svg" alt="회사소개" />
                    </Link>
                  </p>
                </div>
              </div>
            </div>
            <div className="banner-makeit">
              <div className="slide-ltr">
                <img className="img-makeit" src="./images/img-makeit.svg" alt="" />
                <img className="img-makeit-mo" src="./images/img-makeit-mo.svg" alt="" />
              </div>
            </div>
          </div>
          <div className="banner-scrolldown mo-none">
            <img
              className="fade-image"
              src="./images/ico-scrolldown.svg"
              alt="스크롤다운"
              id="fadeImg"
            />
          </div>
        </div>
      </section>

      {/* 인트로 */}
      <section id="main-intro">
        <div
          className="m-auto main-intro-container"
          data-aos="fade-up"
          data-aos-duration="700"
          data-aos-once="true"
        >
          <div className="main-intro-content center-title">
            <div className="line-y"></div>
            <p className="fs-base fw-bold color-primary">TAKE CORPORATION</p>
            <p className="text-center fw-bold fs-xl">
              급변하는 IT 환경에 빠르게 반응하고 수용하여&nbsp;
              <br className="mo-none" />
              수준높은 IT 서비스를 제공합니다.
            </p>
          </div>
        </div>
      </section>

      {/* 핵심제품  */}
      <section id="main-product">
        <div
          className="m-auto main-product-container content-padding"
          data-aos="fade-up"
          data-aos-duration="700"
          data-aos-once="true"
        >
          <div className="center-title">
            <div className="line-hor"></div>
            <p className="fs-base fw-bold color-primary">PRODUCT</p>
            <h1 className="fw-bold">핵심제품</h1>
            <p className="text-center fs-md mt-8">
              고객의 비즈니스에 가치를 더하는 <br className="pc-none" /> 스마트한 솔루션을 만듭니다.
              <br />
              <br className="pc-none" />
              우리는 단순한 제품이 아닌,
              <br className="pc-none" /> 지속 가능한 성장을 위한 해답을 제공합니다.
            </p>
          </div>
          <div
            className="main-product-content"
            data-aos="fade-up"
            data-aos-duration="700"
            data-aos-once="true"
            data-aos-delay="150"
          >
            <ul>
              <li className="main-product-img01" onClick={(e) => handleService('uxbooster')}>
                <img className="product-uxbooster-img" src="./images/logo-uxbooster-white.svg" />
                <div className="product-text">
                  <img className="product-uxbooster-img" src="./images/logo-uxbooster-white.svg" />
                  <p className="fs-base color-white text-center">
                    기업의 다양한 업무 시스템을
                    <br /> 효율적으로 구축할 수 있도록
                    <br />
                    지원하는 웹 기반의 프레임워크
                  </p>
                </div>
              </li>
              <li className="main-product-img02" onClick={(e) => handleService('aichanger')}>
                <img className="product-aichanger-img" src="./images/logo-aichanger-white.svg" />
                <div className="product-text">
                  <img className="product-aichanger-img" src="./images/logo-aichanger-white.svg" />
                  <p className="fs-base color-white text-center">
                    AI 학습 기반의 자동화 기술을 활용하여
                    <br /> C/S 시스템을 웹 표준으로 변환하는
                    <br />
                    스마트 웹 전환 서비스
                  </p>
                </div>
              </li>
              <li className="main-product-img03" onClick={(e) => handleService('gems')}>
                <img className="product-gems-img" src="./images/logo-gems-white.svg" />
                <div className="product-text">
                  <img className="product-gems-img" src="./images/logo-gems-white.svg" />
                  <p className="fs-base color-white text-center mt-4">
                    조직의 온실가스 배출량 데이터를
                    <br /> 쉽고 체계적으로 관리할 수 있는 솔루션
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* 사업영역 */}
      <section id="main-business" className="content-padding">
        <div
          className="m-auto main-business-container"
          data-aos="fade-up"
          data-aos-duration="700"
          data-aos-once="true"
        >
          <div className="center-title">
            <div className="line-hor"></div>
            <p className="fs-base fw-bold color-white">BUSINESS</p>
            <h1 className="fw-bold color-white">사업영역</h1>
            <p className="text-center fs-md mt-8 color-white fw-rg">
              TAKE는 기술 너머의 가능성을 실현합니다.
              <br />
              우리의 사업은 고객의 문제를 해결하고,
              <br className="pc-none" /> 가치를 창출하는 데 집중합니다.
            </p>
          </div>
          <ul
            className="main-business-content"
            data-aos="fade-up"
            data-aos-duration="700"
            data-aos-once="true"
          >
            <li>
              <img src="./images/ico-main-business01.svg" alt="" />
              <p className="color-white fw-bold fs-base">개발 프레임워크 사업</p>
              <p className="color-white text-center fs-base">
                UXBooster 프레임워크&nbsp;
                <br className="mo-none" />
                기반 개발 및 판매
              </p>
            </li>
            <li>
              <img src="./images/ico-main-business02.svg" alt="" />
              <p className="color-white fw-bold fs-base">웹 전환 서비스</p>
              <p className="color-white text-center fs-base">
                기존 C/S 시스템을&nbsp;
                <br className="mo-none" />
                웹기반으로 전환
              </p>
            </li>
            <li>
              <img src="./images/ico-main-business03.svg" alt="" />
              <p className="color-white fw-bold fs-base">ESG 솔루션</p>
              <p className="color-white text-center fs-base">
                지속가능경영을 위한&nbsp;
                <br className="mo-none" />
                ESG 중심 시스템
              </p>
            </li>
            <li>
              <img src="./images/ico-main-business04.svg" alt="" />
              <p className="color-white fw-bold fs-base">구매/입찰 솔루션</p>
              <p className="color-white text-center fs-base">
                기업간 전자구매 및&nbsp;
                <br className="mo-none" />
                입찰관리 시스템
              </p>
            </li>
            <li>
              <img src="./images/ico-main-business05.svg" alt="" />
              <p className="color-white fw-bold fs-base">SI 서비스 및 컨설팅</p>
              <p className="color-white text-center fs-base">
                기업 맞춤형&nbsp;
                <br className="mo-none" />
                시스템 구축 및 컨설팅
              </p>
            </li>
          </ul>
        </div>
      </section>

      {/* 핵심가치 */}
      <section id="main-values">
        <div className="main-values-container content-padding">
          <div
            className="m-auto"
            data-aos="fade-right"
            data-aos-duration="700"
            data-aos-once="true"
          >
            <div className="left-title">
              <div className="line-hor"></div>
              <p className="fs-base fw-bold color-primary">CORE VALUES</p>
              <h1 className="fw-bold">핵심가치</h1>
              <p className="fs-md mt-8">
                TAKE는 고객의 신뢰를 바탕으로 장기적인 파트너십을 구축하며,&nbsp;
                <br className="mo-none" />
                급변하는 디지털 환경속에서도 함께 성장할 수 있는 미래를 만들어 갑니다.
              </p>
            </div>
            <ul className="main-values-content">
              <li
                data-aos="fade-up"
                data-aos-duration="700"
                data-aos-once="true"
                data-aos-delay="150"
              >
                <h3>
                  <strong>T</strong>rust
                </h3>
                <p className="fs-base">
                  고객과의 신뢰를 최우선으로 생각하며
                  <br className="pc-none" /> 안정적이고 검증된 솔루션을 제공합니다.
                </p>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="700"
                data-aos-once="true"
                data-aos-delay="250"
              >
                <h3>
                  <strong>A</strong>gility
                </h3>
                <p className="fs-base">
                  급변하는 IT 환경 속에서도 유연하고 기민하게
                  <br className="pc-none" /> 고객 맞춤형 시스템을 빠르게 구축하여 드립니다.
                </p>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="700"
                data-aos-once="true"
                data-aos-delay="350"
              >
                <h3>
                  <strong>K</strong>nowledge
                </h3>
                <p className="fs-base">
                  지속적인 연구개발과 차별화된 기술력을 제공하여
                  <br className="pc-none" /> 혁신적인 플랫폼과 솔루션을 제공합니다.
                </p>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="700"
                data-aos-once="true"
                data-aos-delay="450"
              >
                <h3>
                  <strong>E</strong>co-friendly
                </h3>
                <p className="fs-base">
                  ESG기반 친환경 솔루션을 개발하여
                  <br className="pc-none" /> 지속 가능한 성장을 위한 기술을 지원합니다.
                </p>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* 레퍼런스 */}
      <section id="main-reference" className="">
        <div
          className="m-auto center-title main-reference-container"
          data-aos="fade-up"
          data-aos-duration="700"
          data-aos-once="true"
        >
          <div className="line-hor"></div>
          <p className="fs-base fw-bold color-primary">REFERENCE</p>
          <h1 className="fw-bold mt-4">
            테이크는 고객과&nbsp;
            <br />
            함께 성장합니다.
          </h1>
        </div>
        <div className="logo-slider">
          <ul className="logo-track">
            <li className="logo">
              <img src="./images/img-logo01.svg" alt="logo01" />
            </li>
            <li className="logo">
              <img src="./images/img-logo02.svg" alt="logo02" />
            </li>
            <li className="logo">
              <img src="./images/img-logo03.svg" alt="logo03" />
            </li>
            <li className="logo">
              <img src="./images/img-logo04.svg" alt="logo04" />
            </li>
            <li className="logo">
              <img src="./images/img-logo05.svg" alt="logo05" />
            </li>
            <li className="logo">
              <img src="./images/img-logo06.svg" alt="logo06" />
            </li>
            <li className="logo">
              <img src="./images/img-logo07.svg" alt="logo07" />
            </li>
            <li className="logo">
              <img src="./images/img-logo08.svg" alt="logo08" />
            </li>
            <li className="logo">
              <img src="./images/img-logo01.svg" alt="logo01" />
            </li>
            <li className="logo">
              <img src="./images/img-logo02.svg" alt="logo02" />
            </li>
            <li className="logo">
              <img src="./images/img-logo03.svg" alt="logo03" />
            </li>
            <li className="logo">
              <img src="./images/img-logo04.svg" alt="logo04" />
            </li>
            <li className="logo">
              <img src="./images/img-logo05.svg" alt="logo05" />
            </li>
            <li className="logo">
              <img src="./images/img-logo06.svg" alt="logo06" />
            </li>
            <li className="logo">
              <img src="./images/img-logo07.svg" alt="logo07" />
            </li>
            <li className="logo">
              <img src="./images/img-logo08.svg" alt="logo08" />
            </li>
          </ul>
        </div>
        <div className="logo-slider">
          <ul className="logo-track reverse">
            <li className="logo">
              <img src="./images/img-logo01.svg" alt="logo01" />
            </li>
            <li className="logo">
              <img src="./images/img-logo02.svg" alt="logo02" />
            </li>
            <li className="logo">
              <img src="./images/img-logo03.svg" alt="logo03" />
            </li>
            <li className="logo">
              <img src="./images/img-logo04.svg" alt="logo04" />
            </li>
            <li className="logo">
              <img src="./images/img-logo05.svg" alt="logo05" />
            </li>
            <li className="logo">
              <img src="./images/img-logo06.svg" alt="logo06" />
            </li>
            <li className="logo">
              <img src="./images/img-logo07.svg" alt="logo07" />
            </li>
            <li className="logo">
              <img src="./images/img-logo08.svg" alt="logo08" />
            </li>
            <li className="logo">
              <img src="./images/img-logo01.svg" alt="logo01" />
            </li>
            <li className="logo">
              <img src="./images/img-logo02.svg" alt="logo02" />
            </li>
            <li className="logo">
              <img src="./images/img-logo03.svg" alt="logo03" />
            </li>
            <li className="logo">
              <img src="./images/img-logo04.svg" alt="logo04" />
            </li>
            <li className="logo">
              <img src="./images/img-logo05.svg" alt="logo05" />
            </li>
            <li className="logo">
              <img src="./images/img-logo06.svg" alt="logo06" />
            </li>
            <li className="logo">
              <img src="./images/img-logo07.svg" alt="logo07" />
            </li>
            <li className="logo">
              <img src="./images/img-logo08.svg" alt="logo08" />
            </li>
          </ul>
        </div>
      </section>

      {/* 문의하기 */}
      <section id="main-contact">
        <div className="main-contact-container">
          <div
            className="m-auto center-title"
            data-aos="fade-up"
            data-aos-duration="700"
            data-aos-once="true"
          >
            <div className="line-hor"></div>
            <p className="fs-base fw-bold color-white">CONTACT</p>
            <h1 className="color-white fw-bold mt-4">
              테이크의 다양한 서비스를&nbsp;
              <br />
              문의해보세요.
            </h1>
            <ul className="contact-button">
              <li>
                <Link to="/contact?service=uxbooster&no=02" className="fw-bold">
                  소개 자료 문의
                </Link>
              </li>
              <li>
                <Link to="/contact?service=uxbooster&no=01" className="btn-filled fw-bold">
                  서비스 도입 문의
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
}

export default Main;
